import React from "react"
import { Tab, Tabs } from "@mui/material"

export const MyTab = ( inputs) => {
    const { defaultTab, tabs, handleTabChange} = inputs.inputs
    return (
        <Tabs value={defaultTab}>
            {tabs.map(tab => {
                return(
                    <Tab label={tab.label} onClick={() => handleTabChange(tab.tab)} key={tab.tab}/>
                )
            })}
        </Tabs>
    )
}